import React, { useEffect, useState } from 'react';
import { aboutData } from '../mockData';
import { siteConfigAPI } from '../services/api';

const AboutPage = () => {
  const [content, setContent] = useState(aboutData.content);

  useEffect(() => {
    siteConfigAPI
      .get()
      .then((config) => {
        if (config?.about_content?.length) setContent(config.about_content);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 pt-32 pb-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-red-700 mb-8">
            About Us
          </h1>
          <div className="bg-white rounded-lg shadow-lg p-8 space-y-6">
            {content.map((paragraph, index) => (
              <p key={`about-${index}`} className="text-gray-700 text-lg leading-relaxed">
                {paragraph}
              </p>
            ))}
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-6">
              <h3 className="text-2xl font-bold text-red-700 mb-4">Our Vision</h3>
              <p className="text-gray-700">
                To be India's most trusted platform for recognizing and celebrating exceptional talents and achievements.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-lg p-6">
              <h3 className="text-2xl font-bold text-red-700 mb-4">Our Mission</h3>
              <p className="text-gray-700">
                To ensure every talented Indian gets their rightful recognition through transparent and fair documentation of their achievements.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
